import axiosInstance from '@/api/axiosInstance'
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'

const REVIEWS_PATH = '/service-reviews/'
const COMPLAINTS_PATH = '/complaints/'

export const useReviews = () => {
    return useQuery({
        queryKey: ['reviews'],
        queryFn: async () => {
            const response = await axiosInstance.get(REVIEWS_PATH)
            return response.data.results || response.data
        },
        staleTime: 60 * 1000,
    })
}

export const useProviderReviews = (providerId?: number) => {
    return useQuery({
        queryKey: ['provider-reviews', providerId || 0],
        queryFn: async () => {
            const response = await axiosInstance.get(`${REVIEWS_PATH}provider_reviews/`, {
                params: { provider_id: providerId }
            })
            return response.data
        },
        enabled: !!providerId,
        staleTime: 60 * 1000,
    })
}

export const useCreateReview = () => {
    const queryClient = useQueryClient()
    return useMutation({
        mutationFn: async (data: { service_request: number; rating: number; comment?: string }) => {
            const response = await axiosInstance.post(REVIEWS_PATH, data)
            return response.data
        },
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['service-requests'] })
            queryClient.invalidateQueries({ queryKey: ['reviews'] })
        },
    })
}

export const useComplaints = () => {
    return useQuery({
        queryKey: ['complaints'],
        queryFn: async () => {
            const response = await axiosInstance.get(COMPLAINTS_PATH)
            return response.data.results || response.data
        },
        staleTime: 60 * 1000,
    })
}

export const useCreateComplaint = () => {
    const queryClient = useQueryClient()
    return useMutation({
        mutationFn: async (data: { service_request: number; subject: string; description: string }) => {
            const response = await axiosInstance.post('/service-complaints/', data)
            return response.data
        },
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['service-requests'] })
            queryClient.invalidateQueries({ queryKey: ['complaints'] })
        },
    })
}


